// Canonical list of routes that the SSG build generates static HTML for.
// Shared by the build scripts (prerender + sitemap) and by the client entry,
// so hydration can only ever be chosen for a route that was really generated.
export const STATIC_ROUTES: string[] = [
  "/",
  "/offerte",
  "/contact",
  "/over-ons",
  "/aanbiedingen",
  "/privacy",
  "/producten",
  "/producten/heren",
  "/producten/dames",
  "/producten/kids-baby",
  "/producten/sport",
  "/producten/workwear",
  "/producten/accessoires",
  "/producten/tassen",
  "/producten/organic",
  "/druktechnieken",
  "/druktechnieken/borduren",
  "/druktechnieken/dtf-printing",
  "/druktechnieken/zeefdrukkerij",
  "/druktechnieken/transferdruk",
  "/textiel-bedrukken",
  "/totally-studentenreizen-hoodies-bestellen",
  "/t-shirt-bedrukken",
  "/tshirt-bedrukken-westland",
  "/t-shirts-bedrukken-in-zoetermeer",
  "/t-shirt-bedrukken-in-rotterdam",
  "/kleding-bedrukken-rotterdam",
  "/sportkleding-bedrukken-2",
  "/bedrijfskleding-werkkleding",
  "/werkkleding-schilders-stukadoors",
  "/algemene-leveringsvoorwaarden",
  "/blog",
  "/zeefdruk-of-transferdruk",
  "/veiligheidsvesten-veiligheidshesjes",
  "/t-shirts-bedrukken-voor-het-zomerseizoen",
];

export const normalizeRoutePath = (pathname: string): string =>
  pathname.replace(/\/+$/, "") || "/";

const STATIC_ROUTE_SET = new Set(STATIC_ROUTES.map(normalizeRoutePath));

export const isStaticRoute = (pathname: string): boolean =>
  STATIC_ROUTE_SET.has(normalizeRoutePath(pathname));
